import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class CitiesService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(
    private http: HttpClient,
  ) { }
  getAllCity(): Observable<any[]> {
    // return this.http.get<any[]>(this.baseUrl + 'getcities');
    return this.http.get<any[]>(this.O3CoreApiUrl + 'City/GetAllCity');
  }
  addNewCity(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'addcity', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'City/AddCity', data);
  }
  updateCity(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'updatecity', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'City/UpdateCity', data);
  }

  deleteCity(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'deletecity', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'City/DeleteCity', data);
  }
}
